import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { TENANT_ORDER_APPROVAL_STATUS } from 'swag-common/constants/order-statuses.constants';
export let Placement = /*#__PURE__*/function (Placement) {
  Placement["RIGHT"] = "right";
  Placement["LEFT"] = "left";
  Placement["TOP"] = "top";
  Placement["BOTTOM"] = "bottom";
  return Placement;
}({});
export const ALL_SWAG_CATEGORY = 'all-swag';
export const BOX_SINGLE_LOGO = 'box-single-product-logo';
export const CONFIRM_INVENTORY_INVITE_REMOVAL_POPUP = 'CONFIRM_INVENTORY_INVITE_REMOVAL_POPUP';
export const SWAG_IN_A_BOX_LANDING = APP_ROUTES.IN_A_BOX;
export const MAX_CUSTOM_BOX_PRODUCTS = 7;
export const MAX_BOX_PRODUCTS = 8;
export const STORAGE_FEE_REPORT_POPUP = 'STORAGE_FEE_REPORT_POPUP';
export const BOX_QUANTITY_EDITOR_POPUP = 'BOX_QUANTITY_EDITOR_POPUP';
export const REGULAR_QUANTITY_EDITOR_POPUP = 'REGULAR_QUANTITY_EDITOR_POPUP';
export const SIZE_EDITOR_POPUP = 'SIZE_EDITOR_POPUP';
export const BOX_PRICE_BREAKDOWN_POPUP = 'BOX_PRICE_BREAKDOWN_POPUP';
export const SAMPLES_DRAWER = 'SAMPLES_DRAWER';
export const INSTANT_QUOTE_POPUP = 'INSTANT_QUOTE_POPUP';
export const SHARE_MOCKUP_DESIGN_DRAWER = 'SHARE_MOCKUP_DESIGN_DRAWER';
export const PRICE_BREAKS_POPUP = 'PRICE_BREAKS_POPUP';
export const ESTIMATE_DISTRIBUTION_FEE_POPUP = 'ESTIMATE_DISTRIBUTION_FEE_POPUP';
export const SPECS_POPUP = 'SPECS_POPUP';
export const REGULAR_SIZE_POPUP = 'REGULAR_SIZE_POPUP';
export const PRODUCTION_TIME_DRAWER = 'PRODUCTION_TIME_DRAWER';
export const PRODUCTION_TIME_DRAWER_FOR_PRODUCT = 'PRODUCTION_TIME_DRAWER_FOR_PRODUCT';
export const TIMELINE_EDITOR_POPUP = 'TIMELINE_EDITOR_POPUP';
export const REMOVE_ITEM_POPUP = 'REMOVE_ITEM_POPUP';
export const RELATED_PRODUCTS = 'relatedProducts';
export const PRODUCTS_CSV_ERROR_POPUP = 'PRODUCTS_CSV_ERROR_POPUP';
export const BULK_UPDATE_POPUP = 'BULK_UPDATE_POPUP';
export const BULK_PRODUCT_SETTINGS_UPDATE_POPUP = 'BULK_PRODUCT_SETTINGS_UPDATE_POPUP';
export const BULK_PRODUCT_ATTRIBUTES_UPDATE_POPUP = 'BULK_PRODUCT_ATTRIBUTES_UPDATE_POPUP';
export const SEARCH_SYNONYMS_UPLOAD_POPUP = 'SEARCH_SYNONYMS_UPLOAD_POPUP';
export const FILTERS_POPUP = 'FILTERS_POPUP';
export const REMOVE_ITEM_FROM_CART_POPUP = 'REMOVE_ITEM_FROM_CART_POPUP';
export const BOX_QUANTITY_CONFLICTS_POPUP = 'BOX_QUANTITY_CONFLICTS_POPUP';
export const ADD_TO_CART_WARNING_POPUP = 'ADD_TO_CART_WARNING_POPUP';
export const NO_DESIGN_POPUP = 'noDesignPopup';
export const ITEMS_VALIDATION_CONFLICTS_POPUP = 'ITEMS_VALIDATION_CONFLICTS_POPUP';
export const REPLACEMENT_ORDER_POPUP = 'REPLACEMENT_ORDER_POPUP';
export const CART_BOXES_SPECIAL_PRODUCTS_WARNING = 'CART_BOXES_SPECIAL_PRODUCTS_WARNING';
export const SEND_TO_CUSTOMER_ADDRESS_POPUP = 'SEND_TO_CUSTOMER_ADDRESS_POPUP';
export const SEND_TO_INVENTORY_WARNING_POPUP = 'SEND_TO_INVENTORY_WARNING_POPUP';
export const GIVEAWAY_ORDER_MORE_POPUP = 'GIVEAWAY_ORDER_MORE_POPUP';
export const GIVEAWAY_PAY_FEES_POPUP = 'GIVEAWAY_PAY_FEES_POPUP';
export const GIVEAWAY_PAYMENT_HISTORY_POPUP = 'GIVEAWAY_PAYMENT_HISTORY_POPUP';
export const LOGIN_POPUP = 'LOGIN_POPUP';
export const SIGNUP_POPUP = 'SIGNUP_POPUP';
export const PRODUCT_TAX_CODE_CREATE_POPUP = 'PRODUCT_TAX_CODE_CREATE_POPUP';
export const PRODUCT_TAX_CODE_DELETE_POPUP = 'PRODUCT_TAX_CODE_DELETE_POPUP';
export const INVENTORY_SETTING_POPUP = 'INVENTORY_SETTING_POPUP';
export const DELETE_PAYMENT_METHOD_POPUP = 'DELETE_PAYMENT_METHOD_POPUP';
export const CHANGE_USER_ROLE_WARNING_POPUP = 'CHANGE_USER_ROLE_WARNING_POPUP';
export const SIZE_SKUS_EDITOR_POPUP = 'SIZE_SKUS_EDITOR_POPUP';
export const ECOMMERCE_PAYMENT_POPUP = 'ECOMMERCE_PAYMENT_POPUP';
export const PFI_PAYMENT_POPUP = 'PFI_PAYMENT_POPUP';
export const INVENTORY_WAREHOUSE_POPUP = 'INVENTORY_WAREHOUSE_POPUP';
export const INVENTORY_WAREHOUSE_PAYMENT_POPUP = 'INVENTORY_WAREHOUSE_PAYMENT_POPUP';
export const PAYMENT_ACCEPTED_POPUP = 'PAYMENT_ACCEPTED_POPUP';
export const PAYMENT_AWAIT_APPROVE_POPUP = 'PAYMENT_AWAIT_APPROVE_POPUP';
export const DEACTIVATE_APPROVAL_SETTING_WARNING_POPUP = 'DEACTIVATE_APPROVAL_SETTING_WARNING_POPUP';
export const INVENTORY_HISTORY_POPUP = 'INVENTORY_HISTORY_POPUP';
export const SEND_NOTICE_TO_WAREHOUSE_POPUP = 'SEND_NOTICE_TO_WAREHOUSE_POPUP';
export const CANCELLATION_POPUP = 'CANCELLATION_POPUP';
export const WAREHOUSE_MOVEMENT_PFI = 'WAREHOUSE_MOVEMENT_PFI';
export const WAREHOUSE_MOVEMENT_CSV = 'WAREHOUSE_MOVEMENT_CSV';
export const WAREHOUSE_MOVEMENT_GIVEAWAY = 'WAREHOUSE_MOVEMENT_GIVEAWAY';
export const ORDER_MORE_BOX_REMOVE_WARNING_POPUP = 'ORDER_MORE_BOX_REMOVE_WARNING_POPUP';
export const ORDER_MORE_BOX_EDIT_WARNING_POPUP = 'ORDER_MORE_BOX_EDIT_WARNING_POPUP';
export const ORDER_INFO_POPUP = 'ORDER_INFO_POPUP';
export const REMOVE_GIVEAWAY_LINK_CONFIRMATION_POPUP = 'REMOVE_GIVEAWAY_LINK_CONFIRMATION_POPUP';
export const CREDITS_INFO_POPUP = 'CREDITS_INFO_POPUP';
export const INVENTORY_CREDITS_POPUP = 'INVENTORY_CREDITS_POPUP';
export const INVENTORY_PAY_CREDITS_POPUP = 'INVENTORY_PAY_CREDITS_POPUP';
export const INVENTORY_BUY_CREDITS_POPUP = 'INVENTORY_BUY_CREDITS_POPUP';
export const INVENTORY_BUY_CREDITS_WITHOUT_ACH_POPUP = 'INVENTORY_BUY_CREDITS_WITHOUT_ACH_POPUP';
export const BUY_CREDITS_BY_CARD_SUCCESS_POPUP = 'BUY_CREDITS_BY_CARD_SUCCESS_POPUP';
export const BUY_CREDITS_BY_ACH_SUCCESS_POPUP = 'BUY_CREDITS_BY_ACH_SUCCESS_POPUP';
export const INVENTORY_WITHDRAW_CREDITS_POPUP = 'INVENTORY_WITHDRAW_CREDITS_POPUP';
export const INVENTORY_WITHDRAW_CREDITS_SUCCESS_POPUP = 'INVENTORY_WITHDRAW_CREDITS_SUCCESS_POPUP';
export const ADMIN_INVENTORY_CREDITS_HISTORY_POPUP = 'ADMIN_INVENTORY_CREDITS_HISTORY_POPUP';
export const ADMIN_INVENTORY_CREDITS_CONFIRMATION_POPUP = 'ADMIN_INVENTORY_CREDITS_CONFIRMATION_POPUP';
export const INVENTORY_FROZEN_ACCOUNT_WARNING_POPUP = 'INVENTORY_FROZEN_ACCOUNT_WARNING_POPUP';
export const ADMIN_INVENTORY_STORAGE_FEE_HISTORY_POPUP = 'ADMIN_INVENTORY_STORAGE_FEE_HISTORY_POPUP';
export const REMOVE_GOODIE_GIVEAWAY_CATEGORY_POPUP = 'REMOVE_GOODIE_GIVEAWAY_CATEGORY_POPUP';
export const GOODIE_GIVEAWAY_CATEGORY_FORM_POPUP = 'GOODIE_GIVEAWAY_CATEGORY_FORM_POPUP';
export const REMOVE_GOODIE_GIVEAWAY_PRODUCT_POPUP = 'REMOVE_GOODIE_GIVEAWAY_PRODUCT_POPUP';
export const SELECT_GIVEAWAY_TYPE_POPUP = 'SELECT_GIVEAWAY_TYPE_POPUP';
export const REMOVE_SELECTED_GOODIE_PRODUCT_POPUP = 'REMOVE_SELECTED_GOODIE_PRODUCT_POPUP';
export const CONFIRM_GOODIE_UNUSED_BUDGET_POPUP = 'CONFIRM_GOODIE_UNUSED_BUDGET_POPUP';
export const GIVEAWAY_COMPLETED_LINKS_POPUP = 'GIVEAWAY_COMPLETED_LINKS_POPUP';
export const GIVEAWAY_EDIT_SINGLE_LINK_POPUP = 'GIVEAWAY_EDIT_SINGLE_LINK_POPUP';
export const GIVEAWAY_PAYMENT_SUCCESS_POPUP = 'GIVEAWAY_PAYMENT_SUCCESS_POPUP';
export const GIVEAWAY_FEEDBACK_POPUP = 'GIVEAWAY_FEEDBACK_POPUP';
export const GIVEAWAY_NOTECARD_NA_POPUP = 'GIVEAWAY_NOTECARD_NA_POPUP';
export const IN_PRODUCTION_POPUP = 'IN_PRODUCTION_POPUP';
export const BOX_CONTENT_POPUP = 'BOX_CONTENT_POPUP';
export const RENAME_PRODUCT_POPUP = 'RENAME_PRODUCT_POPUP';
export const IMAGE_MANAGEMENT_POPUP = 'IMAGE_MANAGEMENT_POPUP';
export const IS_MARK_AS_SHIPPED_POPUP = 'IS_MARK_AS_SHIPPED_POPUP';
export const CONFIRM_CARD_REMOVING_POPUP = 'CONFIRM_CARD_REMOVING_POPUP';
export const CONFIRM_PUBLIC_API_CARD_REMOVING_POPUP = 'CONFIRM_PUBLIC_API_CARD_REMOVING_POPUP';
export const PRODUCT_QUANTITY_ADJUSTMENT_POPUP = 'PRODUCT_QUANTITY_ADJUSTMENT_POPUP';
export const DISTRIBUTION_CANCEL_MESSAGE_POPUP = 'DISTRIBUTION_CANCEL_MESSAGE_POPUP';
export const ADVANCE_DISTRIBUTION_TRIGGER_POPUP = 'ADVANCE_DISTRIBUTION_TRIGGER_POPUP';
export const PRODUCT_ADJUSTMENTS_HISTORY_POPUP = 'PRODUCT_ADJUSTMENTS_HISTORY_POPUP';
export const FAQ_QUESTION_POPUP = 'FAQ_QUESTION_POPUP';
export const REMOVE_FAQ_QUESTION_CONFIRMATION_POPUP = 'REMOVE_FAQ_QUESTION_CONFIRMATION_POPUP';
export const EDIT_EMAIL_TEMPLATE_POPUP = 'EDIT_EMAIL_TEMPLATE_POPUP';
export const EDIT_EMAIL_TEMPLATE_CONFIRM_CLOSE_POPUP = 'EDIT_EMAIL_TEMPLATE_CONFIRM_CLOSE_POPUP';
export const EDIT_EMAIL_TEMPLATE_CONFIRM_SAVE_POPUP = 'EDIT_EMAIL_TEMPLATE_CONFIRM_SAVE_POPUP';
export const END_GIVEAWAY_CONFIRMATION_POPUP = 'END_GIVEAWAY_CONFIRMATION_POPUP';
export const DEMO_INVENTORY_WARNING_POPUP = 'DEMO_INVENTORY_WARNING_POPUP';
export const FIRST_DEMO_INVENTORY_ENTER_POPUP = 'FIRST_DEMO_INVENTORY_ENTER_POPUP';
export const START_INVENTORY_SHOPPING_POPUP = 'START_INVENTORY_SHOPPING_POPUP';
export const DISAPPEAR_DEMO_INVENTORY_WARNING_POPUP = 'DISAPPEAR_DEMO_INVENTORY_WARNING_POPUP';
export const DEMO_INVENTORY_REMINDER_POPUP = 'DEMO_INVENTORY_REMINDER_POPUP';
export const STORAGE_FEE_DESCRIPTION_POPUP = 'STORAGE_FEE_DESCRIPTION_POPUP';
export const GO_BACK_TO_OWN_INVENTORY_POPUP = 'GO_BACK_TO_OWN_INVENTORY_POPUP';
export const END_DEMO_INVENTORY_TOUR_POPUP = 'END_DEMO_INVENTORY_TOUR_POPUP';
export const CHECKOUT_OUT_OF_STOCK_ADJUSTMENT_POPUP = 'CHECKOUT_OUT_OF_STOCK_ADJUSTMENT_POPUP';
export const CONFIRM_YOUR_ADDRESS_POPUP = 'CONFIRM_YOUR_ADDRESS_POPUP';
export const CONFIRM_REMOVE_RECEIVER_POPUP = 'CONFIRM_REMOVE_RECEIVER_POPUP';
export const PULL_FROM_INVENTORY_POPUP = 'PULL_FROM_INVENTORY_POPUP';
export const SHIPOUT_CSV_ERROR_POPUP = 'SHIPOUT_CSV_ERROR_POPUP';
export const SHIPOUT_VALIDATION_POPUP = 'SHIPOUT_VALIDATION_POPUP';
export const FLAT_SHIPPING_RATE_POPUP = 'FLAT_SHIPPING_RATE_POPUP';
export const STORAGE_FEE_SUCCESS_PAYMENT_POPUP = 'STORAGE_FEE_SUCCESS_PAYMENT_POPUP';
export const SEE_REQUEST_CHANGES_POPUP = 'SEE_REQUEST_CHANGES_POPUP';
export const CART_BOX_BUILDER_POPUP = 'CART_BOX_BUILDER_POPUP';
export const BOX_BUILDER_SELECT_PRODUCTS_DRAWER = 'BOX_BUILDER_SELECT_PRODUCTS_DRAWER';
export const PREVENT_UNSAVED_BOX_BUILDER_PROGRESS_POPUP = 'PREVENT_UNSAVED_BOX_BUILDER_PROGRESS_POPUP';
export const SUPER_SPEED_BOX_CONFIRMATION = 'SUPER_SPEED_BOX_CONFIRMATION';
export const SUPER_SPEED_BOX_TYPE_CHANGE_CONFIRMATION = 'SUPER_SPEED_BOX_TYPE_CHANGE_CONFIRMATION';
export const SUPER_SPEED_WARNING_POPUP = 'SUPER_SPEED_WARNING_POPUP';
export const SUPER_SPEED_COLOR_LIMITATION_POPUP = 'SUPER_SPEED_COLOR_LIMITATION_POPUP';
export const VIEW_INVENTORY_PRODUCT_IMAGE_POPUP = 'VIEW_INVENTORY_PRODUCT_IMAGE_POPUP';
export const UPLOAD_PRODUCT_IMAGE_POPUP = 'UPLOAD_PRODUCT_IMAGE_POPUP';
export const VIEW_INVENTORY_PRODUCT_ORDERS_POPUP = 'VIEW_INVENTORY_PRODUCT_ORDERS_POPUP';
export const NON_VECTOR_IMAGE_UPLOAD_POPUP = 'NON_VECTOR_IMAGE_UPLOAD_POPUP';
export const SHOW_ERROR_POPUP = 'SHOW_ERROR_POPUP';
export const ITEM_STALLED_WARNING_POPUP = 'ITEM_STALLED_WARNING_POPUP';
export const GIVEAWAY_AVAILABLE_APPAREL_PRODUCTS_POPUP = 'GIVEAWAY_AVAILABLE_APPAREL_PRODUCTS_POPUP';
export const IN_RESERVE_STOCK_POPUP = 'IN_RESERVE_STOCK_POPUP';
export const IN_RESERVE_PRODUCTION_POPUP = 'IN_RESERVE_PRODUCTION_POPUP';
export const TRANSFER_PRODUCTS_POPUP = 'TRANSFER_PRODUCTS_POPUP';
export const DISTRIBUTION_PRODUCTS_POPUP = 'DISTRIBUTION_PRODUCTS_POPUP';
export const REJECT_APPROVAL_DISTRIBUTION_POPUP = 'REJECT_APPROVAL_DISTRIBUTION_POPUP';
export const CONFIRM_SHIPOUT_REMOVAL_POPUP = 'CONFIRM_SHIPOUT_REMOVAL_POPUP';
export const CHANGE_GIVEAWAY_RESERVE_STATUS_TO_NON_RESERVE_POPUP = 'CHANGE_GIVEAWAY_RESERVE_STATUS_TO_NON_RESERVE_POPUP';
export const CHANGE_GIVEAWAY_RESERVE_STATUS_TO_RESERVE_POPUP = 'CHANGE_GIVEAWAY_RESERVE_STATUS_TO_RESERVE_POPUP';
export const CONFIRM_WAREHOUSE_LOCATION_CHANGE_POPUP = 'CONFIRM_WAREHOUSE_LOCATION_CHANGE_POPUP';
export const TRANSFER_IMPOSSIBLE_POPUP = 'TRANSFER_IMPOSSIBLE_POPUP';
export const WAREHOUSE_LOCATION_HISTORY_POPUP = 'WAREHOUSE_LOCATION_HISTORY_POPUP';
export const BOX_SIZE_POPUP = 'BOX_SIZE_POPUP';
export const CONFIRM_CHANGE_SHIPPING_POPUP = 'CONFIRM_CHANGE_SHIPPING_POPUP';
export const PO_REPORT_EDITOR_POPUP = 'PO_REPORT_EDITOR_POPUP';
export const MARK_AS_DELIVERED_POPUP = 'MARK_AS_DELIVERED_POPUP';
export const CONFIRM_EDIT_ITEM_CHANGES_FOR_SHARED_ITEMS_POPUP = 'CONFIRM_EDIT_ITEM_CHANGES_FOR_SHARED_ITEMS_POPUP';
export const REMOVE_RELATED_ITEM_WARNING_POPUP = 'REMOVE_RELATED_ITEM_WARNING_POPUP';
export const CHANGE_STATUS_SILENTLY_POPUP = 'CHANGE_STATUS_SILENTLY_POPUP';
export const ORDER_MORE_BOX_POPUP = 'ORDER_MORE_BOX_POPUP';
export const ORDER_MORE_BOX_EDIT_QUANTITY_WARNING_POPUP = 'ORDER_MORE_BOX_EDIT_QUANTITY_WARNING_POPUP';
export const SAMPLE_AND_REGULAR_PRODUCTS_POPUP = 'SAMPLE_AND_REGULAR_PRODUCTS_POPUP';
export const DELETE_SIZE_SUBMISSION_POPUP = 'DELETE_SIZE_SUBMISSION_POPUP';
export const GIVEAWAY_BILLING_POPUP = 'GIVEAWAY_BILLING_POPUP';
export const GIVEAWAY_FEES_POPUP = 'GIVEAWAY_FEES_POPUP';
export const GIVEAWAY_NOTECARD_PAY_POPUP = 'GIVEAWAY_NOTECARD_PAY_POPUP';
export const REQUEST_DEMO_POPUP = 'REQUEST_DEMO_POPUP';
export const CONFIRM_OOS_NON_PS_POPUP = 'CONFIRM_OOS_NON_PS_POPUP';
export const GIVEAWAY_NOTECARD_PAYMENT_SUCCESS_POPUP = 'GIVEAWAY_NOTECARD_PAYMENT_SUCCESS_POPUP';
export const CREDITS_QUANTITY_ADJUSTMENT_POPUP = 'CREDITS_QUANTITY_ADJUSTMENT_POPUP';
export const FORGOT_PASSWORD_POPUP = 'FORGOT_PASSWORD_POPUP';
export const CONFIRM_OOS_NON_PS_VARIANT_POPUP = 'CONFIRM_OOS_NON_PS_VARIANT_POPUP';
export const MAIN_INFO_EDITOR_POPUP = 'MAIN_INFO_EDITOR_POPUP';
export const EMBELLISHMENT_METHOD_EDITOR_POPUP = 'EMBELLISHMENT_METHOD_EDITOR_POPUP';
export const BOX_COLOR_EDITOR_POPUP = 'BOX_COLOR_EDITOR_POPUP';
export const GIVEAWAY_NOTECARD_REMAINING_POPUP = 'GIVEAWAY_NOTECARD_REMAINING_POPUP';
export const EDIT_SIZE_BREAKDOWN_POPUP = 'EDIT_SIZE_BREAKDOWN_POPUP';
export const VENDOR_INFO_EDITOR_POPUP = 'VENDOR_INFO_EDITOR_POPUP';
export const FINAL_PAYMENT_POPUP = 'FINAL_PAYMENT_POPUP';
export const CONFIRM_MARK_DELIVERED_POPUP = 'CONFIRM_MARK_DELIVERED_POPUP';
export const SET_NEXT_ITEM_STATUS_POPUP = 'SET_NEXT_ITEM_STATUS_POPUP';
export const SET_NEXT_ITEM_STATUS_PSO_POPUP = 'SET_NEXT_ITEM_STATUS_PSO_POPUP';
export const COMPANY_DOMAIN_TOGGLE_POPUP = 'COMPANY_DOMAIN_TOGGLE_POPUP';
export const COMPANY_DOMAIN_GAMIFICATION_TOGGLE_POPUP = 'COMPANY_DOMAIN_GAMIFICATION_TOGGLE_POPUP';
export const ORDER_DELETE_CONFIRMATION_POPUP = 'ORDER_DELETE_CONFIRMATION_POPUP';
export const DELETE_ABANDONED_ORDER_POPUP = 'DELETE_ABANDONED_ORDER_POPUP';
export const DELETE_EMBELLISHMENT_FROM_PRODUCT_POPUP = 'DELETE_EMBELLISHMENT_FROM_PRODUCT_POPUP';
export const UPLOAD_IMAGE_EDITOR_POPUP = 'UPLOAD_IMAGE_EDITOR_POPUP';
export const REMOVE_LEVEL_CONFIRMATION_POPUP = 'REMOVE_LEVEL_CONFIRMATION_POPUP';
export const COMPANY_DOMAIN_ORDER_FLOW_TOGGLE_POPUP = 'COMPANY_DOMAIN_ORDER_FLOW_TOGGLE_POPUP';
export const SHIPOUT_PAYMENT_CONFIRMATION_POPUP = 'SHIPOUT_PAYMENT_CONFIRMATION_POPUP';
export const WAREHOUSE_PAYMENT_CONFIRMATION_POPUP = 'WAREHOUSE_PAYMENT_CONFIRMATION_POPUP';
export const CUSTOM_ORDER_SHIPPING_INFO_EDITOR_POPUP = 'CUSTOM_ORDER_SHIPPING_INFO_EDITOR_POPUP';
export const ADMIN_BOX_CONTENT_POPUP = 'ADMIN_BOX_CONTENT_POPUP';
export const LOGIN_AS_USER_CONFIRMATION_POPUP = 'LOGIN_AS_USER_CONFIRMATION_POPUP';
export const MOCKUP_WITHDRAW_CONFIRMATION_POPUP = 'MOCKUP_WITHDRAW_CONFIRMATION_POPUP';
export const TRACKING_CSV_UPLOAD_POPUP = 'TRACKING_CSV_UPLOAD_POPUP';
export const CONFIRM_RESOLVE_BACKORDERS_POPUP = 'CONFIRM_RESOLVE_BACKORDERS_POPUP';
export const INVENTORY_ADJUSTMENTS_HISTORY_POPUP = 'INVENTORY_ADJUSTMENTS_HISTORY_POPUP';
export const DISTRIBUTION_HISTORY_POPUP = 'DISTRIBUTION_HISTORY_POPUP';
export const ORDER_MORE_BOX_EDIT_BOX = 'ORDER_MORE_BOX_EDIT_BOX';
export const ORDER_MORE_BOX_ADD_PRODUCTS = 'ORDER_MORE_BOX_ADD_PRODUCTS';
export const VIDEO_POPUP = 'VIDEO_POPUP';
export const DISTRIBUTION_EDITOR_POPUP = 'DISTRIBUTION_EDITOR_POPUP';
export const DISTRIBUTION_EDIT_CONFIRM_POPUP = 'DISTRIBUTION_EDIT_CONFIRM_POPUP';
export const RENAME_SIZE_SUBMISSION_POPUP = 'RENAME_SIZE_SUBMISSION_POPUP';
export const SHIPPING_EDITOR_FORM_POPUP = 'SHIPPING_EDITOR_FORM_POPUP';
export const REORDER_WARNING_POPUP = 'REORDER_WARNING_POPUP';
export const ORDER_EDIT_HISTORY_POPUP = 'ORDER_EDIT_HISTORY_POPUP';
export const ADJUST_STORAGE_FEE_POPUP = 'ADJUST_STORAGE_FEE_POPUP';
export const CONFIRM_GIVEAWAY_MULTIPLE_PRODUCTS = 'CONFIRM_GIVEAWAY_MULTIPLE_PRODUCTS';
export const EDIT_SMA_COLUMN_NAME_POPUP = 'EDIT_SMA_COLUMN_NAME_POPUP';
export const SMA_INVALID_DATA_POPUP = 'SMA_INVALID_DATA_POPUP';
export const LIMITED_EDITION_SETTINGS_POPUP = 'LIMITED_EDITION_SETTINGS_POPUP';
export const DISABLE_LIMITED_EDITION_POPUP = 'DISABLE_LIMITED_EDITION_POPUP';
export const DUMMY_ORDER_DATA_POPUP = 'DUMMY_ORDER_DATA_POPUP';
export const IN_STOCK_POPUP = 'IN_STOCK_POPUP';
export const GIVEAWAY_NOTECARD_ORDER_MORE = 'GIVEAWAY_NOTECARD_ORDER_MORE';
export const GIVEAWAY_NOTECARD_OUT_OF_STOCK_POPUP = 'GIVEAWAY_NOTECARD_OUT_OF_STOCK_POPUP';
export const GIVEAWAY_NOTECARD_NOT_ENOUGH_POPUP = 'GIVEAWAY_NOTECARD_NOT_ENOUGH_POPUP';
export const CONFIRM_CHANGE_SUPER_SPEED_PROD_TIME_POPUP = 'CONFIRM_CHANGE_SUPER_SPEED_PROD_TIME_POPUP';
export const CONFIRM_DEFAULT_WAREHOUSE_CHANGE_POPUP = 'CONFIRM_DEFAULT_WAREHOUSE_CHANGE_POPUP';
export const DEFAULT_WAREHOUSE_HISTORY_POPUP = 'DEFAULT_WAREHOUSE_HISTORY_POPUP';
export const CONFIRM_DEFAULT_PAYMENT_SET_POPUP = 'CONFIRM_DEFAULT_PAYMENT_SET_POPUP';
export const SETTINGS_HISTORY_POPUP = 'SETTINGS_HISTORY_POPUP';
export const TRANSFER_ITEMS_POPUP = 'TRANSFER_ITEMS_POPUP';
export const COLLECT_SIZES_POPUP = 'COLLECT_SIZES_POPUP';
export const INVENTORY_UPSELL_EDIT_QUANTITY_POPUP = 'INVENTORY_UPSELL_EDIT_QUANTITY_POPUP';
export const INVENTORY_UPSELL_EDIT_VARIANTS_QUANTITY_POPUP = 'INVENTORY_UPSELL_EDIT_VARIANTS_QUANTITY_POPUP';
export const CANCEL_UPSELL_EDIT_QUANTITY_CONFIRMATION_POPUP = 'CANCEL_UPSELL_EDIT_QUANTITY_CONFIRMATION_POPUP';
export const CART_ORDER_VERSION_ERROR_TYPE = 'CART_ORDER_VERSION_ERROR_TYPE';
export const CART_ADD_ITEM_ERROR_TYPE = 'CART_ADD_ITEM_ERROR_TYPE';
export const SUPER_SPEED_ERROR_TYPE = 'SUPER_SPEED_ERROR_TYPE';
export const LOGO_UPLOAD_ERROR_TYPE = 'LOGO_UPLOAD_ERROR_TYPE';
export const LOGO_UPLOAD_SIZE_LIMIT_ERROR_TYPE = 'LOGO_UPLOAD_SIZE_LIMIT_ERROR_TYPE';
export const UNREGISTERED_USER_INVITE_ERROR_TYPE = 'UNREGISTERED_USER_INVITE_ERROR_TYPE';
export const HOT_PRODUCT_LIST_POPUP = 'HOT_PRODUCT_LIST_POPUP';
export const CONFIRM_HOT_PRODUCTS_LIST_DELETE = 'CONFIRM_HOT_PRODUCTS_LIST_DELETE';
export const CONFIRM_TRANSFORM_SUPER_SPEED_ITEMS_POPUP = 'CONFIRM_TRANSFORM_SUPER_SPEED_ITEMS_POPUP';
export const UNAVAILABLE_SIZES_POPUP = 'UNAVAILABLE_SIZES_POPUP';
export const EDIT_USER_EMAIL_POPUP = 'EDIT_USER_EMAIL_POPUP';
export const EDIT_USER_EMAIL_HISTORY_POPUP = 'EDIT_USER_EMAIL_HISTORY_POPUP';
export const EDIT_SIZE_POPUP = 'EDIT_SIZE_POPUP';
export const EDIT_BOX_NOTECARD_POPUP = 'EDIT_BOX_NOTECARD_POPUP';
export const EDIT_BOX_NOTECARD_PREVENT_CLOSE_POPUP = 'EDIT_BOX_NOTECARD_PREVENT_CLOSE_POPUP';
export const NOTECARD_REVIEW_PREVENT_CLOSE_POPUP = 'NOTECARD_REVIEW_PREVENT_CLOSE_POPUP';
export const MOCKUP_MANAGER_POPUP = 'mockupManager';
export const EDIT_PRINT_LOCATIONS_POPUP = 'EDIT_PRINT_LOCATIONS_POPUP';
export const CHECKOUT_PRINT_LOCATION_WARNINGS_POPUP = 'CHECKOUT_PRINT_LOCATION_WARNINGS_POPUP';
export const COMPANY_ART_FOLDER_POPUP = 'COMPANY_ART_FOLDER_POPUP';
export const COMPANY_ART_FOLDER_ALL_LOGOS_POPUP = 'COMPANY_ART_FOLDER_ALL_LOGOS_POPUP';
export const CONFIRM_DELETE_ART_FOLDER_LOGO_POPUP = 'CONFIRM_DELETE_ART_FOLDER_LOGO_POPUP';
export const APPROVE_APPLICATION_POPUP = 'APPROVE_APPLICATION_POPUP';
export const DEBOSSED_EMBELISHMENT_METHOD_POPUP = 'DEBOSSED_EMBELISHMENT_METHOD_POPUP';
export const LASER_ENGRAVED_EMBELISHMENT_METHOD_POPUP = 'LASER_ENGRAVED_EMBELISHMENT_METHOD_POPUP';
export const CHANGE_WITHDRAWAL_STATUS_POPUP = 'CHANGE_WITHDRAWAL_STATUS_POPUP';
export const APPROVE_RESELLER_CERTIFICATE_POPUP = 'APPROVE_RESELLER_CERTIFICATE_POPUP';
export const REJECT_RESELLER_CERTIFICATE_POPUP = 'REJECT_RESELLER_CERTIFICATE_POPUP';
export const PERMISSION_ERROR_POPUP = 'PERMISSION_ERROR_POPUP';
export const RESELLER_ADMIN_MODE_EXIT_POPUP = 'RESELLER_ADMIN_MODE_EXIT_POPUP';
export const RESELLER_ADMIN_CREATE_CART_LINK_POPUP = 'RESELLER_ADMIN_CREATE_CART_LINK_POPUP';
export const COMMENT_PREBUILT_LIMITED_CART_POPUP = 'COMMENT_PREBUILT_LIMITED_CART_POPUP';
export const COMMENT_PREBUILT_LIMITED_CART_SUCCESS_POPUP = 'COMMENT_PREBUILT_LIMITED_CART_SUCCESS_POPUP';
export const RESELLER_ADMIN_CREATE_INVOICE_POPUP = 'RESELLER_ADMIN_CREATE_INVOICE_POPUP';
export const AUTO_REPLENISH_POPUP = 'AUTO_REPLENISH_POPUP';
export const CONFIRM_REMOVE_PRODUCT_POPUP = 'CONFIRM_REMOVE_PRODUCT_POPUP';
export const RESELLER_COMMISSION_BONUS_POPUP = 'RESELLER_COMMISSION_BONUS_POPUP';
export const RESELLER_COMMISSION_BONUS_HISTORY_POPUP = 'RESELLER_COMMISSION_BONUS_HISTORY_POPUP';
export const BUILD_A_CART_INFO_FORM_POPUP = 'BUILD_A_CART_INFO_FORM_POPUP';
export const BUILD_A_CART_TYPE_POPUP = 'BUILD_A_CART_TYPE_POPUP';
export const BUILD_A_CART_CREATE_LINK_POPUP = 'BUILD_A_CART_CREATE_LINK_POPUP';
export const BUILD_A_CART_REMOVE_CONFIRMATION_POPUP = 'BUILD_A_CART_REMOVE_CONFIRMATION_POPUP';
export const ADMIN_MODE_EXIT_POPUP = 'ADMIN_MODE_EXIT_POPUP';
export const SWAG_BUNDLE_CONFIRMATION_LEAVE_POPUP = 'SWAG_BUNDLE_CONFIRMATION_LEAVE_POPUP';
export const SWAG_BUNDLE_CONFIRMATION_SELECTED_PRODUCTS_QUANTITIES_POPUP = 'SWAG_BUNDLE_CONFIRMATION_SELECTED_PRODUCTS_QUANTITIES_POPUP';
export const RESELLER_REFERRALS_INFO_POPUP = 'RESELLER_REFERRALS_INFO_POPUP';
export const SWAG_BUNDLE_DELETE_CONFIRMATION_POPUP = 'SWAG_BUNDLE_DELETE_CONFIRMATION_POPUP';
export const SWAG_BUNDLE_DELETE_NOT_ALLOWED_SINCE_ACTIVITY_POPUP = 'SWAG_BUNDLE_DELETE_NOT_ALLOWED_SINCE_ACTIVITY_POPUP';
export const EMBELLISHMENT_CHANGE_PRODUCTION_TIME_CONFIRMATION_POPUP = 'EMBELLISHMENT_CHANGE_PRODUCTION_TIME_CONFIRMATION_POPUP';
export const ITEM_EMBELLISHMENT_CHANGE_PRODUCTION_TIME_CONFIRMATION_POPUP = 'ITEM_EMBELLISHMENT_CHANGE_PRODUCTION_TIME_CONFIRMATION_POPUP';
export const EMBELLISHMENT_CHANGE_LOCATION_CONFIRMATION_POPUP = 'EMBELLISHMENT_CHANGE_LOCATION_CONFIRMATION_POPUP';
export const SWAG_BUNDLE_DELETE_NOT_ALLOWED_SINCE_PACKAGING_POPUP = 'SWAG_BUNDLE_DELETE_NOT_ALLOWED_SINCE_PACKAGING_POPUP';
export const SWAG_BUNDLE_ORDER_MORE_POPUP = 'SWAG_BUNDLE_ORDER_MORE_POPUP';
export const SHOPIFY_ORDER_MARK_IGNORED_POPUP = 'SHOPIFY_ORDER_MARK_IGNORED_POPUP';
export const SWAG_BUNDLE_ADDONS_SUCCESSFULLY_ORDERED_POPUP = 'SWAG_BUNDLE_ADDONS_SUCCESSFULLY_ORDERED_POPUP';
export const TRIGGER_ADVANCED_DISTRIBUTION_ERROR_POPUP = 'TRIGGER_ADVANCED_DISTRIBUTION_ERROR_POPUP';
export const SWAG_BUNDLE_EDIT_ADDONS_REMOVE_APPROVING_POPUP = 'SWAG_BUNDLE_EDIT_ADDONS_REMOVE_APPROVING_POPUP';
export const SWAG_BUNDLE_EDIT_REMOVE_PACKAGE_NOT_ALLOWED_POPUP = 'SWAG_BUNDLE_EDIT_REMOVE_PACKAGE_NOT_ALLOWED_POPUP';
export const MAX_PRINT_COLORS_LIMIT_EXCEEDED_POPUP = 'MAX_PRINT_COLORS_LIMIT_EXCEEDED_POPUP';
export const DISTRIBUTION_SHUTDOWN_RESTRICTION_POPUP = 'DISTRIBUTION_SHUTDOWN_RESTRICTION_POPUP';
export const BOXES_ROUTE = `${APP_ROUTES.COLLECTIONS}/boxes`;
export const OTHER_SUBCATEGORY_NAME = 'Other';
export const DEFAULT_QUANTITY = 100;
export const FREE = 'FREE';
export const DEFAULT_HIDDEN_PAGINATION_PAGE_SIZE = 12;
export const CBS_HIDDEN_CATEGORIES_PRODUCT_COUNT = 12;
export const PAGE = 'page';
export const TOOLBAR_ITEMS = {
  DESIGN_NOTE: 'DESIGN_NOTE',
  ADD_TEXT: 'ADD_TEXT',
  CENTER_LOGO: 'CENTER_LOGO',
  EDIT_COLORS: 'EDIT_COLORS',
  CONVERT_COLORS: 'CONVERT_COLORS'
};
export const HISTORY_TABS = {
  EVERYBODY: 'everybody',
  JUST_YOU: 'just-you'
};
export const EXPAND_ICON_POSITION = {
  up: 'up',
  down: 'down',
  left: 'left',
  right: 'right'
};
export const PRODUCTS_COUNT_IN_A_ROW = 9;
export const LOGIN_FOR_FAVOURITES_TITLE = 'You need to login to add to favorites!';
export const LOGIN_FOR_FAVOURITES_LINK_TITLE = 'You need to login to see your favorites!';
export const LOGIN_FOR_SAVE_A_DESIGN = 'You need to login to save a design!';
export const LOGIN_FOR_COLLECT_SIZES = 'You need to login to collect sizes!';
export const VARIANT_COLORS = {
  darkblue: '#00008b',
  yellowgreen: '#9acd32',
  orange: '#ffa500',
  pink: '#ffc0cb',
  brown: '#a52a2a',
  silver: '#c0c0c0',
  red: '#ff0000',
  blue: '#0000ff',
  green: '#008000',
  purple: '#800080',
  gray: '#808080',
  black: '#000000',
  white: '#ffffff',
  yellow: '	#ffff00'
};
export const MATERIAL_TRANSITION_TIME = 255;
export let ReduxFormNames = /*#__PURE__*/function (ReduxFormNames) {
  ReduxFormNames["SendNoticeToWarehouse"] = "SendNoticeToWarehouse";
  ReduxFormNames["UserEditorForm"] = "userEditorForm";
  ReduxFormNames["UserEditEmailForm"] = "UserEditEmailForm";
  ReduxFormNames["EditEmailTemplateForm"] = "EditEmailTemplateForm";
  ReduxFormNames["POEditorForm"] = "poEditorForm";
  ReduxFormNames["EcommerceEditShippingForm"] = "EcommerceEditShippingForm";
  ReduxFormNames["CustomStoreEditShippingForm"] = "CustomStoreEditShippingForm";
  ReduxFormNames["StallProductForm"] = "StallProductForm";
  ReduxFormNames["AdjustStorageFeesForm"] = "AdjustStorageFeesForm";
  ReduxFormNames["SignUpForm"] = "SignUpForm";
  ReduxFormNames["ChangePasswordForm"] = "ChangePasswordForm";
  ReduxFormNames["SetPasswordByLoggedInForm"] = "SetPasswordByLoggedInForm";
  ReduxFormNames["InvitationForm"] = "InvitationForm";
  ReduxFormNames["SetPasswordFromPageForm"] = "SetPasswordFromPageForm";
  ReduxFormNames["DummyOrderDataForm"] = "DummyOrderDataForm";
  ReduxFormNames["GoodieCategoryForm"] = "GoodieCategoryForm";
  ReduxFormNames["GoodieGiveawayProductForm"] = "GoodieGiveawayProductForm";
  ReduxFormNames["PaymentMethodCardForm"] = "paymentMethodForm";
  ReduxFormNames["InstantQuoteEmailForm"] = "instantQuoteEmailForm";
  return ReduxFormNames;
}({});

//starting popup for promo pages
export const PROMO_PAGE_STARTING_POPUP = 'PROMO_PAGE_STARTING_POPUP';

//starting popup for promo pages config
export const PROMO_PAGE_STARTING_POPUP_CONFIG = {
  SPRING: {
    startingDelay: 1800,
    title: 'Welcome Capital One® Spring® customers',
    description: 'For all Capital One® Spring® users, please use promo code Spring20 for 20% off of your Swag purchases! Also if you want to use our Swag Distribution Platform to easily send swag to different addresses, you can with 6 months of free storage.'
  }
};
export const SHOW_LOADER_AFTER_MS = 100;
export const TENANT_ORDER_STATUS_LABELS = {
  [TENANT_ORDER_APPROVAL_STATUS.PENDING]: 'Pending\u00A0approval',
  [TENANT_ORDER_APPROVAL_STATUS.APPROVED]: 'Approved',
  [TENANT_ORDER_APPROVAL_STATUS.REJECTED]: 'Rejected'
};
export const DEFAULT_PAGINATION_PROPS = {
  locale: {
    items_per_page: 'Items per page',
    jump_to: 'Jump to',
    jump_to_confirm: 'Jump to confirm',
    page: 'page',
    prev_page: 'Prev',
    next_page: 'Next',
    prev_5: 'Prev 5',
    next_5: 'Next 5',
    prev_3: 'Prev 3',
    next_3: 'Next 3'
  }
};
export const HEADER_BRANDS_LINE_SIZE = 9;
export const PAYMENT_SETTINGS = 'payment-settings';
export const PAYMENT_DETAILS_SENDOSO = 'paymentDetailsSendoso';
export const PAYMENT_DETAILS_PUBLIC_API = 'paymentDetailsPublicApi';
export { SPECIAL_BUNDLE_NAME } from './tenant-name';
export let AddressManualType = /*#__PURE__*/function (AddressManualType) {
  AddressManualType["ADDRESS_ENTERED"] = "entered";
  AddressManualType["ADDRESS_SUGGESTED"] = "suggested";
  return AddressManualType;
}({});
export const OUT_OF_STOCK_EMAIL_SUBSCRIPTION = 'OUT_OF_STOCK_EMAIL_SUBSCRIPTION';
export const notAllowedEditInDraftTooltip = 'This product is part of a box. Please edit it from your cart.';
export const reduxFormForceDestroyFlag = '__REDUX_FORM_FORCE_DESTROY';
export const INVALID_ORDER_VERSION_ERROR_MESSAGE = 'Please refresh the page to show the most recent changes.';
export const ITEM_STALLED_WARNING_MESSAGE = 'Note that the item you are updating is stalled.';
export const MY_ORDERS_PLACEHOLDERS_COUNT = 3;
export const SUPER_SPEED = ' - Super Speed';
export const SUPER_SPEED_ADDON_WARN_TEXT = 'Addons cannot be included in Super Speed boxes, so your current box is not Super Speed. To make your box Super Speed, please remove Addons from the box or replace them with another Super Speed product.';
export const PHONE_NUMBER_TOOLTIP = 'Your phone number will only be used to contact you with questions related to your order.  It will not be used for any other purposes.';
export const SEND_TO_INVENTORY_WITH_SPLIT_SHIPPED_ITEMS_CONFIRMATION_POPUP = 'SEND_TO_INVENTORY_WITH_SPLIT_SHIPPED_ITEMS_CONFIRMATION_POPUP';
export const UNABLE_TO_USE_SUPER_SPEED_FOR_SPLIT_SHIPPED_POPUP = 'UNABLE_TO_USE_SUPER_SPEED_FOR_SPLIT_SHIPPED_POPUP';
export const BUNDLE_IN_PRODUCTION_POPUP = 'BUNDLE_IN_PRODUCTION_POPUP';
export const STORE_LINK_AND_MAKE_IT_LIVE_POPUP = 'STORE_LINK_AND_MAKE_IT_LIVE_POPUP';
export const MINIMUM_REQUIRED_CBS_POPUP = 'MINIMUM_REQUIRED_CBS_POPUP';
export const BUNDLE_IN_STOCK_POPUP = 'BUNDLE_IN_STOCK_POPUP';
export const FINISH_SWAG_BUNDLE_POPUP = 'FINISH_SWAG_BUNDLE_POPUP';
export const TOO_MANY_ATTEMPTS_ERROR_TEXT = "Too many failed login attempts, please click 'Forgot password?' or try again later.";
export const SWAG_BUNDLE_SHARED_PRODUCT_POPUP = 'SWAG_BUNDLE_SHARED_PRODUCT_POPUP';
export const SWAG_BUNDLE_BOX_CONTENT_CHANGED_POPUP = 'SWAG_BUNDLE_BOX_CONTENT_CHANGED_POPUP';
export const SHIPOUT_SHUTDOWN_NOTICE_POPUP = 'SHIPOUT_SHUTDOWN_NOTICE_POPUP';